<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 28.10.2022
  -- Description : Formulaire de création d'un ARE depuis la liste des ARE
  -- Fichier : CreateJobSearchAssistanceFromList.vue
  -->

<template>
  <v-row>
    <v-form
      ref="formCreateJobSearchAssistance"
      v-model="validCreateJobSearchAssistance"
      lazy-validation
    >
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="mx-3" color="primary">
            Ajouter un ARE
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un ARE</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="jobSearchAssistance.address"
              label="Adresse"
            ></v-text-field>
            <v-text-field
              v-model="jobSearchAssistance.town"
              label="Ville"
            ></v-text-field>
            <v-text-field
              v-model="jobSearchAssistance.zipCode"
              label="Code postale"
            ></v-text-field>

            <v-autocomplete
              v-model="jobSearchAssistance.typeJobSearchAssistanceOccurrenceId"
              :items="
                typeJobSearchAssistanceOccurrence.typeSearchAssistanceOccurrences
              "
              item-value="typeJobSearchAssistanceOccurrenceId"
              item-text="description"
              label="Occurrence"
              clearable
            ></v-autocomplete>
            <v-menu
              ref="menuCreation"
              v-model="menuCreation"
              :close-on-content-click="true"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="jobSearchAssistance.date"
                  label="Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="jobSearchAssistance.date"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
            <v-text-field
              v-model="jobSearchAssistance.description"
              label="Description"
            ></v-text-field>
            <v-text-field
              v-model="jobSearchAssistance.website"
              label="Site internet"
            ></v-text-field>
            <v-text-field
              v-model="jobSearchAssistance.keyWords"
              label="Mots clés"
            ></v-text-field>
            <v-autocomplete
              v-model="jobSearchAssistance.typeJobSearchAssistanceId"
              :items="typeJobSearchAssistance.typeSearchAssistances"
              item-value="typeJobSearchAssistanceId"
              item-text="description"
              label="Type"
              clearable
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import { mapState } from 'vuex'
import NProgress from 'nprogress'

function getEntreprises() {
  store.dispatch('entreprise/fetchEntreprises', {}).then(() => {})
}

function getTypeJobSearchAssistances() {
  store
    .dispatch('typeJobSearchAssistance/fetchTypeJobSearchAssistances', {})
    .then(() => {})
}

function getTypeJobSearchAssistanceOccurrences() {
  store
    .dispatch(
      'typeJobSearchAssistanceOccurrence/fetchtypeSearchAssistanceOccurrences',
      {}
    )
    .then(() => {})
}

export default {
  data: () => ({
    validCreateJobSearchAssistance: true,
    dialog: false,
    jobSearchAssistance: {
      jobSearchAssistanceId: 0,
      address: null,
      town: null,
      zipCode: null,
      date: null,
      description: null,
      website: null,
      keyWords: null,
      typeJobSearchAssistanceId: null,
      typeJobSearchAssistanceOccurrenceId: null
    },
    menuCreation: false,
    date: null
  }),

  // Charger les différents possibilités de choix avant la création du composant
  beforeCreate(routeTo, routeFrom, next) {
    getEntreprises(routeTo, next)
    getTypeJobSearchAssistances(routeTo, next)
    getTypeJobSearchAssistanceOccurrences(routeTo, next)
  },

  created() {
    console.log(
      this.typeJobSearchAssistanceOccurrence.typeSearchAssistanceOccurrences
    )
  },

  computed: {
    ...mapState([
      'typeJobSearchAssistance',
      'typeJobSearchAssistanceOccurrence'
    ])
  },

  methods: {
    // Si le formulaire est valide, création du contact
    submit() {
      if (this.$refs.formCreateJobSearchAssistance.validate()) {
        NProgress.start()
        store
          .dispatch(
            'jobSearchAssistance/createJobSearchAssistance',
            this.jobSearchAssistance
          )
          .then(() => {
            let jobSearchAssistanceClone = JSON.parse(
              JSON.stringify(
                store.state.jobSearchAssistance.jobSearchAssistance
              )
            )
            this.addNewData(jobSearchAssistanceClone)
            this.$refs.formCreateJobSearchAssistance.reset()
          })
          .catch(() => {})
        this.dialog = false
        NProgress.done()
      }
    },
    // Ajoute le contact à l'entreprise
    addNewData(data) {
      store
        .dispatch('jobSearchAssistance/addJobSearchAssistance', data)
        .then(() => {})
        .catch(() => {})
    }
  }
}
</script>
